import { render } from "./ListeCategorieClient.vue?vue&type=template&id=6d32e668&ts=true"
import script from "./ListeCategorieClient.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__